import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20gradient%20background%20with%20soft%20flowing%20curves%20and%20minimalist%20geometric%20elements%2C%20elegant%20corporate%20style%2C%20warm%20cream%20and%20amber%20tones%2C%20clean%20modern%20design%2C%20subtle%20texture%2C%20no%20text&width=1920&height=600&seq=mjhl-cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-black/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-bold text-white">
            准备好探索 <strong>MJHL</strong> 了吗？
          </h2>
          <p className="mt-4 text-sm md:text-base text-white/80 leading-relaxed max-w-xl mx-auto">
            无论您是个人用户、企业客户还是合作伙伴，MJHL 都能为您提供卓越的产品与服务体验。立即联系我们，开启合作之旅。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/categories"
              className="px-8 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
            >
              探索产品
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 border border-white/60 text-white font-medium rounded-md hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
            >
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}